import connectToStores from "alt-utils/lib/connectToStores";
import React, { Component } from "react";

import ConfigStore from "../../stores/chat/ConfigStore";

class AskQuestionFormHeader extends Component {
    static getStores() {
        return [ConfigStore];
    }

    static getPropsFromStores() {
        return {
            labels: ConfigStore.getConfig().labels,
        };
    }

    render() {
        return <h1 className="header-title">{this.props.labels.askFormHeader}</h1>;
    }
}

export default connectToStores(AskQuestionFormHeader);
